const state = {
  multiSelection: false
}

const mutations = {
  toggleMultiselection: (): boolean => state.multiSelection = !state.multiSelection,
  enableMultiselection: (): boolean => state.multiSelection = true,
  disableMultiselection: (): boolean => state.multiSelection = false
}

const getters = {
  isMultiselection: (): boolean => state.multiSelection
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}